import { HashRouter, Routes, Route, Navigate } from "react-router-dom";

import POSPage from "./PosPage";
import RepairsPage from "./RepairsPage";
import ProductPage from "./ProductPage";
import LoginPage from "./LoginPage";
import ReportsPage from "./ReportsPage";
import ShopSettingsPage from "./ShopSettingsPage";
import AdminLayout from "./AdminLayout";
import LicencePage from "./LicencePage";
import SalesPage from "./SalesPage";
import SuperAdminPage from "./SuperAdminPage";
import ActivationPage from "./ActivationPage";
import TillActivationPage from "./TillActivationPage";
import DashboardPage from "./DashboardPage";
import ProtectedRoute from "./ProtectedRoute";
import StaffPage from "./StaffPage";
import SuperAdminTillsPage from "./SuperAdminTillsPage";
import SuperAdminSalesPage from "./SuperAdminSalesPage";
import ProfitReportPage from "./ProfitReportPage";
import RefundReportPage from "./RefundReportPage";
import SuppliersPage from "./SuppliersPage";
import PurchaseCategoriesPage from "./PurchaseCategoriesPage";
import PurchasesPage from "./PurchasesPage";
import PromotionsPage from "./PromotionsPage";
import MultiBuyPromotionsPage from "./MultiBuyPromotionsPage";
import LabelsPage from "./LabelsPage";
import BillingDashboardPage from "./BillingDashboardPage";

function App() {
  const isAdminDomain = window.location.hostname === "admin.deskpos.ie";
  return (
    <HashRouter>
      <Routes>
        {/* Login pages */}
        <Route path="/login" element={<LoginPage mode="pos" />} />
        <Route path="/admin-login" element={<LoginPage mode="admin" />} />

        {/* POS screen - should redirect to POS login */}
        <Route
          path="/"
          element={
            isAdminDomain ? (
              <Navigate to="/admin-login" replace />
            ) : (
              <ProtectedRoute
                allowedRoles={["shop_admin", "manager", "cashier"]}
                redirectTo="/login"
              >
                <POSPage />
              </ProtectedRoute>
            )
          }
        />

        <Route
          path="/repairs"
          element={
            <ProtectedRoute
              allowedRoles={["shop_admin", "manager", "cashier"]}
              redirectTo="/login"
            >
              <RepairsPage />
            </ProtectedRoute>
          }
        />

        {/* Admin dashboard - should redirect to admin login */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute
              allowedRoles={["shop_admin", "manager"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <DashboardPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/inventory"
          element={
            <ProtectedRoute
              allowedRoles={["shop_admin", "manager"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <ProductPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/promotions"
          element={
            <ProtectedRoute
              allowedRoles={["shop_admin", "manager"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <PromotionsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/multi-buy-promotions"
          element={
            <ProtectedRoute
              allowedRoles={["shop_admin", "manager"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <MultiBuyPromotionsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/suppliers"
          element={
            <ProtectedRoute
              allowedRoles={["shop_admin", "manager"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <SuppliersPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/purchase-categories"
          element={
            <AdminLayout>
              <PurchaseCategoriesPage />
            </AdminLayout>
          }
        />

        <Route
          path="/purchases"
          element={
            <AdminLayout>
              <PurchasesPage />
            </AdminLayout>
          }
        />

        <Route
          path="/reports"
          element={
            <ProtectedRoute
              allowedRoles={["shop_admin", "manager"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <ReportsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/sales"
          element={
            <ProtectedRoute
              allowedRoles={["shop_admin", "manager"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <SalesPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/staff"
          element={
            <ProtectedRoute
              allowedRoles={["shop_admin"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <StaffPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/shop-settings"
          element={
            <ProtectedRoute
              allowedRoles={["shop_admin"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <ShopSettingsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/licence"
          element={
            <ProtectedRoute
              allowedRoles={["shop_admin", "manager"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <LicencePage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/super-admin"
          element={
            <ProtectedRoute
              allowedRoles={["super_admin"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <SuperAdminPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/super-admin/sales"
          element={
            <ProtectedRoute
              allowedRoles={["super_admin"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <SuperAdminSalesPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/super-admin/billing"
          element={
            <ProtectedRoute
              allowedRoles={["super_admin"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <BillingDashboardPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/super-admin/tills"
          element={
            <ProtectedRoute
              allowedRoles={["super_admin"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <SuperAdminTillsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/profit-report"
          element={
            <ProtectedRoute
              allowedRoles={["shop_admin", "manager"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <ProfitReportPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/refund-report"
          element={
            <ProtectedRoute
              allowedRoles={["shop_admin", "manager"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <RefundReportPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/labels"
          element={
            <ProtectedRoute
              allowedRoles={["shop_admin", "manager"]}
              redirectTo="/admin-login"
            >
              <AdminLayout>
                <LabelsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route path="/labels" element={<LabelsPage />} />

        <Route path="/activate" element={<ActivationPage />} />
        <Route path="/activate-till" element={<TillActivationPage />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
